import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  wisprService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface WisprPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function WisprPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: WisprPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="wispr"
      displayName="Wispr Flow"
      description="Connect your Wispr Flow account to access your meeting notes, transcripts, and calendar directly in conversations."
      features={[
        'Search your Wispr Flow meetings',
        'Pull up transcripts, summaries, and attendees',
        'Surface action items and decisions',
        'Look up the events on your Wispr Flow calendar',
      ]}
      accentColor="slate"
      events={{
        modalOpened: OnboardingEvents.WISPR_MODAL_OPENED,
        oauthStarted: OnboardingEvents.WISPR_OAUTH_STARTED,
        connected: OnboardingEvents.WISPR_CONNECTED,
        connectionFailed: OnboardingEvents.WISPR_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.WISPR_MODAL_CLOSED,
      }}
      service={wisprService}
    />
  );
}
